<template>
    <div class="politics-project-flow-page politics-project-flow-page--compact">
        <div class="main-workflow">
            <div class="project-flow-toolbar">
                <h2 class="project-flow-toolbar__title">
                    招标项目名称：{{ projectInfo.projectName }}
                    <span class="project-flow-toolbar__code">招标项目编号：{{ projectInfo.projectNumber }}</span>
                </h2>
                <el-button type="primary" icon="el-icon-back" @click="handleBack" class="project-flow-toolbar__back">
                    返回
                </el-button>
            </div>
            <div class="workflow-stage main-stage">
                <div v-for="(stage, index) in mainTitles" :key="`main-${index}`" class="workflow-item">
                    <img :src="stage.leftImage" :alt="`${stage.name}`" class="decoration-image" />
                    <div class="content-wrapper">
                        <div class="content main-content"
                            :style="{ backgroundColor: stage.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            style="border-radius: 0px;   box-shadow: 0 2px 4px rgba(0, 0, 0, 0); display: flex; align-items: center;justify-content: center;">
                            {{ stage.name }}
                        </div>
                        <div class="content-overlay"></div>
                    </div>
                    <img :src="stage.rightImage" :alt="`${stage.name}`" class="decoration-image" />
                </div>
            </div>

            <!-- 第一阶段 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in mainStages" :key="value.name"
                    @click="handleStageClick(value)">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : require('@/assets/image/bidProProcess-one-after.png')"
                                class="stage-icon" />
                        </div>
                        <div class="content" @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.name }}</div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 第二阶段 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in secondaryStages" :key="value.name"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage">
                <div v-for="stage in finalStages" :key="`final-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">
                            {{ stage.name }}</div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage">
                <div v-for="stage in reviewStages" :key="`review-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass == 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">{{ stage.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage">
                <div v-for="stage in reportStages" :key="`report-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">
                            {{ stage.name }}</div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 创建一条虚线 -->
            <div class="workflow-line">
                <div class="workflow-line-item">
                    <span class="workflow-line-text">附加流程</span>
                </div>
            </div>

            <div class="workflow-stage additional">
                <div v-for="stage in endStages1" :key="`end1-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass == 'teal' ? require('@/assets/image/bidProProcess-two-right.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon hidden" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass == 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">{{ stage.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage additional">
                <div v-for="stage in endStages2" :key="`end2-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass == 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">{{ stage.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage additional">
                <div v-for="stage in endStages3" :key="`end3-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass == 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">{{ stage.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>

            <div class="workflow-stage additional">
                <div v-for="stage in endStages4" :key="`end4-${stage.id}`" class="workflow-item"
                    @click="handleStageClick(stage)" :style="{ visibility: stage.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === stage.name ? require('@/assets/image/bidProProcess-hover-after.png') : (stage.colorClass != 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass == 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = stage.name" @mouseleave="hoveredStage = null">{{ stage.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" class="stage-decoration hidden" />
                </div>
            </div>
        </div>

        <!-- 标段列表弹窗 -->
        <el-dialog title="选择标段导出投标人名单" :visible.sync="sectionDialog.visible" width="600px" :close-on-click-modal="false"
            :append-to-body="true">
            <el-table :data="sectionDialog.list" style="width: 100%" border>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="sectionName" label="标段名称" min-width="300"
                    show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleExportAvoidList(scope.row)">
                            导出投标人名单
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sectionDialog.visible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getProjectDetail, onclickArchiving } from '@/api/agent/api'
import { getProjectTypeName } from '@/utils/base'
import { getSectionInfoByProjectCode } from '@/api/base/api'
import Cookies from 'js-cookie'
import { baseUrl } from '@/utils/base.js'
import axios from 'axios'

export default {
    name: 'PoliticsProjectFlow',
    data() {
        return {
            // 当前悬停的阶段名称
            hoveredStage: null,
            // 当前项目类型
            projectType: '',
            // 项目编号
            projectCode: '',
            // 项目ID
            projectId: '',

            // 项目基本信息
            projectInfo: {
                projectNumber: '',
                projectName: '',
                projectType: ''
            },
            procurementType: this.$route.query.procurementType,//1 企业采购 2:政府采购 3:建设工程

            // 标段列表弹窗
            sectionDialog: {
                visible: false,
                list: []
            },
            // 路由配置映射表
            routeConfig: {
                7: { path: '/agentHome/politicsProjectCreate', needsProjectParams: true },
                8: { path: '/agentHome/tenderProMgmt', needsProjectParams: true },
                9: { path: '/agentHome/politicsProjectManage', needsProjectParams: true },
                10: { path: '/agentHome/qualificationReview', needsProjectParams: true },
                11: { path: '/agentHome/judgeInfoEntry', needsProjectParams: true },
                12: { path: this.$route.query.procurementType == 3 || this.$route.query.type == '公开招标项目信息' ? '/agentHome/winningBidCandidates' : '/agentHome/winningBidAnnouncement', needsProjectParams: true },
                14: { path: '/agentHome/bidEvaluationMethodList', needsProjectParams: true },
                16: { path: '/agentHome/bidOpeningHall', needsProjectParams: true },
                17: { path: '/agentHome/valuationbefore', needsProjectParams: true },
                18: { path: this.$route.query.procurementType == 3 || this.$route.query.type == '公开招标项目信息' ? '/agentHome/winningBidAnnouncement' : '/agentHome/bidResultNotification', needsProjectParams: true },
                20: { path: null, needsProjectParams: true, dynamic: true }, // 动态路由
                22: { path: '/agentHome/qualificationReviewList', needsProjectParams: true },
                23: { path: '/agentHome/printReviewResults', needsProjectParams: true },
                24: { path: '/agentHome/bidResultNotification', needsProjectParams: true },
                28: { path: '/agentHome/qualificationReviewList', needsProjectParams: true },
                29: { path: '/agentHome/evaluationReport', needsProjectParams: true },
                30: { path: '/agentHome/contract', needsProjectParams: true },
                38: { path: '/agentHome/tenderDocumentClarification', needsProjectParams: true },
                39: { action: 'message', message: '导出回避单位' }, // 特殊操作
                40: { path: '/agentHome/calculateBidScore', needsProjectParams: true },
                41: { path: '/agentHome/expertQuestionView', needsProjectParams: true },
                42: { path: '/agentHome/oneClickArchive', needsProjectParams: true },
                44: { path: '/agentHome/answerBidderQuestions', needsProjectParams: true },
                48: { path: '/agentHome/exportBidAnalysis', needsProjectParams: true },
                50: { path: '/agentHome/pioneerList?type=3', needsProjectParams: true },
                54: { path: '/agentHome/bidTermination', needsProjectParams: true },
                60: { path: '/agentHome/bidComplaint', needsProjectParams: true }

            },

            // 主要流程标题
            mainTitles: [
                {
                    id: 1,
                    name: '招标方案',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue',
                },
                {
                    id: 2,
                    name: '发标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal',
                },
                {
                    id: 3,
                    name: '投标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue',
                },
                {
                    id: 4,
                    name: '开标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal',

                },
                {
                    id: 5,
                    name: '评标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue',
                },
                {
                    id: 6,
                    name: '定标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal',
                }
            ],
            // 第一阶段子流程
            mainStages: [
                {
                    id: 7,
                    name: '创建标段',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 8,
                    name: '制作招标文件',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 9,
                    name: '投标文件',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 10,
                    name: '设置审查资格',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 11,
                    name: '组建评标委员会',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 12,
                    name: this.$route.query.procurementType == 3 || this.$route.query.type == '公开招标项目信息' ? '中标候选人公示' : '中标公告',
                    colorClass: 'blue',
                    visibility: false,
                }
            ],

            // 第二阶段子流程
            secondaryStages: [
                {
                    id: 13,
                    name: '担保凭证',
                    colorClass: 'teal',
                    visibility: true,
                },
                {
                    id: 14,
                    name: '编制评标办法',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 10086,
                    name: '321',
                    colorClass: 'teal',
                    visibility: true,
                },
                {
                    id: 16,
                    name: '进入开标大厅',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 17,
                    name: '评标前准备',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 18,
                    name: this.$route.query.procurementType == 3 || this.$route.query.type == '公开招标项目信息' ? '中标公告' : '中标结果通知书',
                    colorClass: 'teal',
                    visibility: false,
                }



            ],

            // 定标阶段流程 - 将在 computed 中定义
            //审查阶段流程
            reviewStages: [
                {
                    id: 25,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 26,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 27,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 28,
                    name: '资格审查',
                    colorClass: 'blue',
                    visibility: false,
                },
                {
                    id: 29,
                    name: '评标报告',
                    colorClass: 'blue',
                    visibility: true,
                },
                {
                    id: 30,
                    name: '添加招标合同',
                    colorClass: 'teal',
                    visibility: true,
                },
            ],
            //报告阶段
            reportStages: [
                {
                    id: 31,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 32,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 33,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 34,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 35,
                    name: '评标报告',
                    colorClass: 'teal',
                    visibility: false,
                },
                {
                    id: 36,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }

            ],
            // 结束阶段1
            endStages1: [

                {
                    id: 37,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                },
                {
                    id: 38,
                    name: '招标文件澄清与修改',
                    colorClass: 'blue',
                    visibility: true,

                },
                {
                    id: 39,
                    name: '导出回避单位',
                    colorClass: 'teal',
                    visibility: true,

                }, {
                    id: 40,
                    name: '计算报价分',
                    colorClass: 'teal',
                    visibility: true,

                }, {
                    id: 41,
                    name: '查看专家质疑',
                    colorClass: 'teal',
                    visibility: true,

                }, {
                    id: 42,
                    name: '一键归档',
                    colorClass: 'teal',
                    visibility: true,

                },
            ],
            // 结束阶段2
            endStages2: [
                {
                    id: 43,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                },
                {
                    id: 44,
                    name: '解答投标人问题',
                    colorClass: 'blue',
                    visibility: true,

                },
                {
                    id: 45,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 46,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 47,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 48,
                    name: '导出异常行为识别结果',
                    colorClass: 'blue',
                    visibility: true,

                }
            ],
            // 结束阶段3
            endStages3: [
                {
                    id: 49,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                },
                {
                    id: 50,
                    name: '勘探通知',
                    colorClass: 'blue',
                    visibility: this.$route.query.procurementType == 3 ? true : false,

                },
                {
                    id: 51,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 52,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 53,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 54,
                    name: '招标异常终止',
                    colorClass: 'blue',
                    visibility: true,

                }
            ],
            // 结束阶段4
            endStages4: [
                {
                    id: 55,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                },
                {
                    id: 56,
                    name: '',
                    colorClass: 'blue',
                    visibility: false,

                },
                {
                    id: 57,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 58,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 59,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,

                }, {
                    id: 60,
                    name: '公示公告质疑投诉',
                    colorClass: 'blue',
                    visibility: true,

                }
            ]


        }
    },
    computed: {
        // 定标阶段流程 - 根据项目类型动态生成
        finalStages() {
            return [
                {
                    id: 19,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                    description: '确定中标人'
                },
                {
                    id: 20,
                    name: this.projectType === '邀请招标项目信息' || this.projectType === '单一来源项目信息' ? '发布邀请书' : '发布招标公告',
                    colorClass: 'teal',
                    visibility: true,
                    status: 'in_progress',
                    description: '定标流程第一步'
                },
                {
                    id: 21,
                    name: '',
                    colorClass: 'teal',
                    visibility: false,
                    description: '定标流程第二步'
                },
                {
                    id: 22,
                    name: '资格审查',
                    colorClass: 'teal',
                    visibility: true,
                    description: '定标流程第三步'
                },
                {
                    id: 23,
                    name: '打印评审结果',
                    colorClass: 'teal',
                    visibility: true,
                    description: '定标流程第四步'
                },
                {
                    id: 24,
                    name: '中标结果通知书',
                    colorClass: 'teal',
                    visibility: this.$route.query.procurementType == 3 || this.$route.query.type == '公开招标项目信息' ? true : false,
                    description: '定标流程第五步'
                }
            ]
        }
    },
    mounted() {
        this.projectType = this.$route.query.type
        this.projectCode = this.$route.query.projectCode
        this.projectId = this.$route.query.projectId
        this.getProjectDetail(this.$route.query.projectCode)
    },
    methods: {
        //获取项目详情
        getProjectDetail(projectCode) {
            getProjectDetail({ projectCode }).then(res => {
                if (res.code === 200) {
                    this.projectInfo.projectNumber = res.data.projectCode
                    this.projectInfo.projectName = res.data.projectName
                    this.projectInfo.projectType = getProjectTypeName(res.data.projectType)
                } else {
                    this.$message.error(res.msg || '获取项目详情失败')
                }
            }).catch(error => {
                console.error('获取项目详情失败:', error)
                this.$message.error('获取项目详情失败')
            })
        },

        /**
         * 返回上一页
         */
        handleBack() {
            this.$router.go(-1)
        },
        //路由查询
        buildQueryParams(needsProjectParams = true) {
            if (!needsProjectParams) {
                return
            }
            return {
                projectCode: this.projectCode,
                projectId: this.projectId,
                procurementType: this.procurementType,
                type: this.projectType
            }
        },
        // 获取动态路由路径
        getDynamicRoutePath() {
            const isInviteOrSingleSource =
                this.projectType === '邀请招标项目信息' ||
                this.projectType === '单一来源项目信息'
            return isInviteOrSingleSource
                ? '/agentHome/newSingleSource'
                : '/agentHome/publishTenderAnnouncement'
        },
        // 执行路由跳转
        navigateToRoute(path, query) {
            this.$router.push({ path, query })
        },
        // 点击阶段处理
        handleStageClick(stage) {
            console.log(stage.id);
            if (stage.id == 39) {
                this.getSectionInfoByProjectCode()

                return
            }
            if (stage.id == 42) {
                this.onclickArchiving()
                return
            }
            const config = this.routeConfig[stage.id]
            // 如果没有配置，直接返回
            if (!config) {
                return
            }
            // 构建查询参数
            const query = this.buildQueryParams(config.needsProjectParams)
            // 处理动态路由
            if (config.dynamic) {
                const path = this.getDynamicRoutePath()
                this.navigateToRoute(path, query)
                return
            }
            // 处理普通路由
            if (config.path) {
                this.navigateToRoute(config.path, query)
            }
        },
        //一键归档
        onclickArchiving() {
            const loading = this.$loading({
                lock: true,
                text: '正在生成归档文件...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            onclickArchiving(this.projectCode).then(res => {
                if (res.code === 200) {
                    // 获取下载链接
                    const downloadUrl = res.data
                    if (downloadUrl) {
                        // 创建隐藏的 a 标签触发下载
                        const link = document.createElement('a')
                        link.href = downloadUrl
                        link.download = `项目归档_${this.projectCode}_${new Date().getTime()}.zip`
                        link.style.display = 'none'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        this.$message.success('归档文件下载成功')
                    } else {
                        this.$message.error('未获取到下载链接')
                    }
                } else {
                    this.$message.error(res.msg || '归档失败')
                }
            }).catch(error => {
                console.error('归档请求异常:', error)
                this.$message.error('请求异常，请稍后重试')
            }).finally(() => {
                loading.close()
            })
        },
        //  获取标段列表
        getSectionInfoByProjectCode() {
            getSectionInfoByProjectCode(this.projectCode).then(res => {
                if (res.code === 200) {
                    const data = res.data || []
                    const validSections = data.filter(item => item.sectionName && item.sectionCode)

                    if (validSections.length > 0) {
                        this.sectionDialog.list = validSections
                        this.sectionDialog.visible = true
                    } else {
                        this.$message.warning('暂无标段信息')
                    }
                } else {
                    this.$message.error(res.msg || '获取标段信息失败')
                }
            }).catch(error => {
                console.error('获取标段信息失败:', error)
                this.$message.error('获取标段信息失败')
            })
        },

        // 导出投标人名单
        handleExportAvoidList(row) {
            this.$confirm(`确定要导出「${row.sectionName}」的投标人名单吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.exportAvoidListBySectionCode(row.sectionCode)
            }).catch(() => {
                // 用户取消
            })
        },
        // 调用导出接口
        exportAvoidListBySectionCode(sectionCode) {
            axios({
                method: 'get',
                url: `/api/agent/additional/process/avoid/export?sectionCode=${sectionCode}`,
                responseType: 'blob',
                baseURL: baseUrl,
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('token')
                }
            }).then(response => {
                const blob = response.data
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.style.display = 'none'
                const fileName = `投标人名单_${sectionCode}_${new Date().getTime()}.xlsx`
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                setTimeout(() => {
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                }, 100)

                this.$message.success('导出成功')
            }).catch(error => {
                console.error('导出失败:', error)
                this.$message.error('导出失败，请重试')
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.politics-project-flow-page {
    .apply-minimal-gray-theme();
}

.politics-project-flow-page--compact {
    margin: 0;
    padding: 0;
}

// 页面头部
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.page-subtitle {
    color: @gray-600;
    margin: 4px 0 0 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
}

.project-flow-toolbar {
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
}

.project-flow-toolbar__title {
    flex: 1;
    margin: 0;
    color: @gray-700;
    font-size: 25px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
    word-break: break-word;
}

.project-flow-toolbar__code {
    display: inline-block;
    margin-left: 10px;
}

.project-flow-toolbar__back {
    flex-shrink: 0;
    margin-left: auto;
}

// 主要流程区域
.main-workflow {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    overflow-x: auto;
    // margin-top: 20px;

    .workflow-stage {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 16px;
        min-width: max-content;
        margin-top: 10px;

        &:first-child {
            margin-top: 0;
        }

        &.additional {
            margin-top: 16px;
        }

        .workflow-item {
            display: flex;
            align-items: center;
            height: 45px;
            flex-shrink: 0;
            cursor: pointer;
            transition: transform 0.2s ease;
            margin-top: 10px;

            &:hover {
                transform: translateY(-2px);
            }

            .stage-decoration {
                height: 45px;
                width: auto;
                flex-shrink: 0;

                &.hidden {
                    visibility: hidden;
                }
            }

            .content-wrapper {
                position: relative;
                height: 45px;
                width: 200px;
                min-width: 180px;
                flex-shrink: 0;
            }

            .content {
                height: 45px;
                width: 200px;
                min-width: 180px;
                text-align: center;
                line-height: 45px;
                font-size: 14px;
                color: #fff;
                font-weight: 600;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                border-radius: 25px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                background-color: #11c2eb;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }


            }

            .main-content {
                border-radius: 4px;
                font-size: 15px;
            }

            .content-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: transparent;
                z-index: 10;
                pointer-events: auto;
            }

            .stage-icon-content {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .stage-icon {
                    margin: auto;
                    width: 14px;
                    height: 9px;

                    &.hidden {
                        visibility: hidden;
                    }
                }
            }
        }
    }

    // 主阶段特殊样式
    .main-stage {

        .workflow-item {
            .decoration-image {
                height: 45px;
                width: auto;
                flex-shrink: 0;
            }
        }
    }

    // 虚线样式
    .workflow-line {
        margin-top: 40px;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: relative;

        .workflow-line-item {
            width: 100%;
            height: 2px;
            background: repeating-linear-gradient(to right,
                    @gray-400 0px,
                    @gray-400 10px,
                    transparent 10px,
                    transparent 20px);
            border-radius: 1px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            .workflow-line-text {
                position: absolute;
                background-color: #fff;
                padding: 8px 20px;
                color: @gray-600;
                font-size: 14px;
                font-weight: 600;
                border-radius: 20px;
                white-space: nowrap;
                border: 1px solid @gray-200;
            }
        }
    }
}

// 弹窗样式
/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

/deep/ .el-table {
    border-radius: 4px;
    overflow: hidden;

    th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

@media (max-width: 768px) {
    .politics-project-flow-page {
        padding: 16px;
    }

    .project-flow-toolbar {
        flex-direction: column;
        align-items: stretch;
        min-height: auto;
    }

    .project-flow-toolbar__title {
        font-size: 18px;
        text-align: left;
    }

    .project-flow-toolbar__code {
        display: block;
        margin-left: 0;
        margin-top: 6px;
    }

    .project-flow-toolbar__back {
        margin-left: 0;
        align-self: flex-start;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .page-subtitle {
        font-size: 14px;
    }

    .main-workflow {
        padding: 16px;

        .workflow-stage {
            gap: 12px;
        }
    }
}
</style>
